import styled from 'styled-components';
import colors from 'styles/colors';
import media from 'styles/media';
import PillButton from 'components/buttons/PillButton';

export const Grid = styled.div`
  ${({ showImage, gap }) =>
    showImage
      ? `
      display: grid;
      gap: 20px;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    `
      : `
      display: flex;
      flex-wrap: wrap;
      gap: ${gap};
    `}

  ${media.medium`    
    display: grid;
    gap: 15px;
    grid-template-columns: 1fr 1fr 1fr;
    ${({ showImage, gap }) =>
      !showImage
        ? `
        display: flex;
        flex-wrap: wrap;
        gap: ${gap};
      `
        : `      
      `}
    
    `}
  ${media.small`
    display: grid;
    grid-template-columns: 1fr 1fr ;
    ${({ showImage, gap }) =>
      !showImage
        ? `
        display: flex;
        flex-wrap: wrap;
        gap: ${gap};
      `
        : `      
      `}  
    
    `}
`;

export const Placeholder = styled.div`
  background: ${colors.secondary.deepCoveVeryLight};
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 5px;
`;

export const Button = styled(PillButton)`
  margin-left: 5px;
  @media (max-width: 389px) {
    display: block;
    margin-bottom: 5px;
  }
`;

export const ButtonWrap = styled.div`
  display: inline-block;
  transition: opacity 0.2s cubic-bezier(0, 0, 0, 0);
  &.disabled {
    opacity: 0.25;
    pointer-events: none;
  }
`;
